<template>
  <li>
    <a href="#" @click.prevent="request()"><slot></slot></a>
  </li>
</template>

<script>
import { request } from "@/utils/wol.js";

export default {
  props: { computers: Array },
  methods: {
    request() {
      if (this.$store.state.socket.connected) {
        if (request(this.computers)) {
          this.$helpers.notify(
            "Wake on LAN",
            "The command has been sent.",
            "success"
          );
        } else this.$helpers.notify("Failed", "The request failed.", "warning");
      } else
        this.$helpers.notify(
          "Not connected",
          "No connection to the server.",
          "warning"
        );
    }
  }
};
</script>
